module.exports = __webpack_public_path__ + "static/media/gold-member.be887a0c.png";